import React from "react";
import { Box, Typography, IconButton, Collapse, Divider } from "@mui/material";
import { ExpandMore as ExpandMoreIcon, ExpandLess as ExpandLessIcon } from "@mui/icons-material";
import { useTheme } from "@mui/material/styles";
import FilterBar from "../../../../components/FilterNSearchBar/FilterNSearchBar";
import { buttonBaseStyles } from "../InfraResources/shared/sharedStyles";

const ResourcesTableContainer = ({
  title = "Resources",
  searchTerm,
  onSearchChange,
  clearFilters,
  filteredCount,
  countLabel,
  tableExpanded,
  onToggleExpand,
  selectedCount,
  selectedLabel,
  markExceptionButton,
  remediateButton,
  leftAction = null,
  children,
  filters = [],
  selectedFilter = null,
  onFilterChange = () => { }
}) => {
  const theme = useTheme();

  return (
    <Box sx={{ display: "flex", flexDirection: "column" }}>
      <Box
        sx={{
          borderRadius: "12px",
          border: `1px solid ${theme.customColors.border.main}`,
          overflow: "hidden",
          display: "flex",
          flexDirection: "column",
          backgroundColor: theme.customColors.background.main,
          boxShadow: theme.customColors.shadow.main,
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            px: 3,
            py: 1.5,
            borderBottom: tableExpanded ? `1px solid ${theme.customColors.border.main}` : "none",
            backgroundColor: theme.customColors.background.cardHeader,
            cursor: "pointer",
          }}
          onClick={onToggleExpand}
        >
          <Box sx={{ display: "flex", alignItems: "center", gap: 3, minWidth: 0 }}>
            {typeof title === "string" ? (
              <Typography
                variant="h5"
                sx={{
                  fontWeight: 600,
                  fontSize: "1rem",
                  color: theme.customColors.text.strong,
                }}
              >
                {title}
              </Typography>
            ) : (
              title
            )}
            {leftAction && (
              <Box onClick={(e) => e.stopPropagation()}>
                {leftAction}
              </Box>
            )}
          </Box>
          <IconButton
            size="small"
            sx={{
              color: theme.palette.text.primary,
              "&:hover": {
                backgroundColor: "transparent"
              }
            }}
          >
            {tableExpanded ? <ExpandLessIcon /> : <ExpandMoreIcon />}
          </IconButton>
        </Box>

        <Collapse in={tableExpanded}>
          <Box
            sx={{
              p: 2,
              pb: 1.5,
              backgroundColor: theme.customColors.background.main,
            }}
          >
            <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start" }}>
              <Box sx={{ flex: 1 }}>
                <FilterBar
                  searchQuery={searchTerm}
                  onSearchChange={onSearchChange}
                  filterLabel=""
                  filters={filters}
                  selectedFilter={selectedFilter}
                  onFilterChange={onFilterChange}
                  onClearFilters={clearFilters}
                  countLabel={countLabel || `${filteredCount} ${filteredCount === 1 ? 'resource' : 'resources'} found`}
                />
              </Box>
              {remediateButton && (
                <Box sx={{ ml: 2, display: "flex", alignItems: "center", height: "40px", mt: "0px" }}>
                  {remediateButton}
                </Box>
              )}
              {markExceptionButton && (
                <Box sx={{ ml: 2, display: "flex", alignItems: "center", height: "40px", mt: "0px" }}>
                  {markExceptionButton}
                </Box>
              )}
            </Box>
            {selectedCount > 0 && selectedLabel && (
              <Typography variant="body2" sx={{ color: "primary.main", fontWeight: 600, mt: 1 }}>
                {selectedCount} {selectedLabel}
              </Typography>
            )}
          </Box>

          <Divider sx={{ borderColor: theme.customColors.border.main }} />

          <Box>
            {children}
          </Box>
        </Collapse>
      </Box>
    </Box>
  );
};

export default ResourcesTableContainer;

